module.exports = (__webpack_require__(65673))(5372);